var _path, _g, _path2, _g2, _path3, _g3, _path4, _g4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAiAnimationBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 501,
    height: 495,
    viewBox: "0 0 501 495",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "first-path",
    d: "M468.656 254.771C468.656 286.277 445.318 315.669 405.664 337.417C366.157 359.085 311.306 372.61 250.501 372.61C189.695 372.61 134.844 359.085 95.3369 337.417C55.6833 315.669 32.3457 286.277 32.3457 254.771C32.3457 223.264 55.6833 193.872 95.3369 172.124C134.844 150.457 189.695 136.931 250.501 136.931C311.306 136.931 366.157 150.457 405.664 172.124C445.318 193.872 468.656 223.264 468.656 254.771Z",
    stroke: "url(#paint4_linear_11641_19719)",
    strokeWidth: 7
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 18,
    fill: "white",
    filter: "url(#filter0_d_11588_17190)"
  }, /*#__PURE__*/React.createElement("animateMotion", {
    dur: "2.5s",
    repeatCount: "indefinite"
  }, /*#__PURE__*/React.createElement("mpath", {
    href: "#first-path"
  }))), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_11588_17190",
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 20,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_11588_17190"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0588235 0 0 0 0 0.364706 0 0 0 0 0.517647 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_11588_17190"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_11588_17190",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_11641_19719",
    x1: 12.3034,
    y1: 30.2218,
    x2: 40.3898,
    y2: 42.2631,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FFF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#1AADF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#109AFD"
  }))))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "second-path",
    d: "M240.233 462.657C208.726 462.657 179.334 439.319 157.586 399.666C135.919 360.159 122.393 305.308 122.393 244.502C122.393 183.696 135.919 128.845 157.586 89.3383C179.334 49.6848 208.726 26.3472 240.233 26.3472C271.739 26.3472 301.131 49.6848 322.879 89.3383C344.547 128.845 358.072 183.697 358.072 244.502C358.072 305.308 344.547 360.159 322.879 399.666C301.131 439.319 271.739 462.657 240.233 462.657Z",
    stroke: "url(#paint4_linear_11641_19719)",
    strokeWidth: 7
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 18,
    fill: "white",
    filter: "url(#filter0_d_11588_17190)"
  }, /*#__PURE__*/React.createElement("animateMotion", {
    dur: "2.5s",
    repeatCount: "indefinite"
  }, /*#__PURE__*/React.createElement("mpath", {
    href: "#second-path"
  }))), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_11588_17190",
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 20,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_11588_17190"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0588235 0 0 0 0 0.364706 0 0 0 0 0.517647 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_11588_17190"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_11588_17190",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_11641_19719",
    x1: 12.3034,
    y1: 30.2218,
    x2: 40.3898,
    y2: 42.2631,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FFF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#1AADF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#109AFD"
  }))))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "third-path",
    d: "M397.499 406.022C375.221 428.301 337.935 432.582 294.518 419.921C251.261 407.306 202.911 378.085 159.915 335.089C116.919 292.093 87.6976 243.743 75.083 200.486C62.4217 157.069 66.7031 119.783 88.9814 97.5045C111.26 75.2262 148.546 70.9448 191.963 83.6061C235.22 96.2206 283.569 125.442 326.565 168.438C369.562 211.434 398.783 259.784 411.398 303.041C424.059 346.458 419.777 383.744 397.499 406.022Z",
    stroke: "url(#paint4_linear_11641_19719)",
    strokeWidth: 7
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 18,
    fill: "white",
    filter: "url(#filter0_d_11588_17190)"
  }, /*#__PURE__*/React.createElement("animateMotion", {
    dur: "2.5s",
    repeatCount: "indefinite"
  }, /*#__PURE__*/React.createElement("mpath", {
    href: "#third-path"
  }))), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_11588_17190",
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 20,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_11588_17190"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0588235 0 0 0 0 0.364706 0 0 0 0 0.517647 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_11588_17190"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_11588_17190",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_11641_19719",
    x1: 12.3034,
    y1: 30.2218,
    x2: 40.3898,
    y2: 42.2631,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FFF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#1AADF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#109AFD"
  }))))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "forth-path",
    d: "M412.023 97.5058C434.302 119.784 438.583 157.07 425.922 200.487C413.307 243.744 384.086 292.094 341.09 335.09C298.093 378.086 249.744 407.307 206.487 419.922C163.07 432.583 125.784 428.302 103.505 406.023C81.2271 383.745 76.9458 346.459 89.6071 303.042C102.222 259.785 131.443 211.435 174.439 168.439C217.435 125.443 265.785 96.2219 309.042 83.6074C352.459 70.9461 389.745 75.2274 412.023 97.5058Z",
    stroke: "url(#paint4_linear_11641_19719)",
    strokeWidth: 7
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 18,
    fill: "white",
    filter: "url(#filter0_d_11588_17190)"
  }, /*#__PURE__*/React.createElement("animateMotion", {
    dur: "2.5s",
    repeatCount: "indefinite"
  }, /*#__PURE__*/React.createElement("mpath", {
    href: "#forth-path"
  }))), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_11588_17190",
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 20,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_11588_17190"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0588235 0 0 0 0 0.364706 0 0 0 0 0.517647 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_11588_17190"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_11588_17190",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_11641_19719",
    x1: 12.3034,
    y1: 30.2218,
    x2: 40.3898,
    y2: 42.2631,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FFF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#1AADF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#109AFD"
  }))))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M248.077 288.052H195.85L186.229 314.681H169.736L213.03 195.624H231.069L274.191 314.681H257.698L248.077 288.052ZM243.61 275.339L221.963 214.865L200.317 275.339H243.61Z",
    fill: "#ffffff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M308.693 194.937V314.681H293.059V194.937H308.693Z",
    fill: "#ffffff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiAnimationBlue);
export default __webpack_public_path__ + "static/media/AI-animation-blue.18f35a800aa0747811bbd09e24eec09d.svg";
export { ForwardRef as ReactComponent };